// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19itc0ux{border:var(--_6l0v0b)}\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._16qsp2xt{box-shadow:var(--ds-shadow-overlay,0 3px 6px rgba(0,0,0,.2))}\n._1bah1yb4{justify-content:space-between}\n._1bsb1edt{width:350px}\n._1e0c1txw{display:flex}\n._1tke5x59{min-height:340px}\n._1ul91edt{min-width:350px}\n._2lx21bp4{flex-direction:column}\n._4t3iixjv{height:375px}\n._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}\n._c71l1y6z{max-height:calc(80vh - 86px)}", ""]);
// Exports
module.exports = exports;
